import { createBrowserClient } from "@supabase/ssr";
import { Database } from "@/types/database.types";
import { AscendSession } from "@/types";
import { jwtDecode } from "jwt-decode";

export const createClient = () =>
	createBrowserClient<Database>(
		process.env.NEXT_PUBLIC_SUPABASE_URL!,
		process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
	);

export const getSession = async () => {
	const supabase = createClient();
	try {
		const [user, session] = await Promise.all([
			supabase.auth.getUser(),
			supabase.auth.getSession(),
		]);

		if (!user.data.user) {
			console.error("No user found");
			return null;
		}

		const token = session.data.session?.access_token;

		if (!token) {
			console.error("No token found");
			return null;
		}

		const decodedSession = jwtDecode(token) as AscendSession;
		return {
			...decodedSession,
			id: user.data.user.id,
		};
	} catch (error) {
		console.error("Error fetching session:", error);
		return null;
	}
};

export const getUserClient = async () => {
	const supabase = createClient();
	const user = await supabase.auth.getUser();
	return user.data.user;
};
